/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { UpdateCourseSectionOptions, UpdateCourseSectionResponses } from '../../models/UpdateCourseSection'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Update Course Section
 * {@link /admin/course/:course_id/sections/:section_id}
 */
export function updateCourseSection<ThrowOnError extends boolean = true>(options: Options<UpdateCourseSectionOptions, ThrowOnError>): Promise<UnwrappedResult<UpdateCourseSectionResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'PATCH', url: '/admin/course/{course_id}/sections/{section_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<UpdateCourseSectionResponses, ThrowOnError>>
}
